import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { db } from "./firebase";
import { serverTimestamp, setDoc, updateDoc, doc, getDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import StudentLayout from "./StudentLayout";
import { BlockMath } from "react-katex";
import Latex from "react-latex-next";
import "katex/dist/katex.min.css";
import "./MillionaireGame.css";

const MillionaireGame = () => {
  // Wrap a string in inline/block LaTeX delimiters if it doesn't have any.
// --- LaTeX helpers ---
const hasDelims = (s = "") =>
  /^\$[\s\S]*\$$/.test(s.trim()) ||
  /^\$\$[\s\S]*\$\$/.test(s.trim()) ||
  /^\\\([\s\S]*\\\)$/.test(s.trim()) ||
  /^\\\[[\s\S]*\\\]$/.test(s.trim());

const looksLikeLatex = (s = "") =>
  /\\[a-zA-Z]+|\\frac|\\sqrt|\\times|\\cdot|\\pounds|\\dfrac|[_^]/.test(s) || hasDelims(s);

// If it looks like LaTeX but lacks delimiters, wrap it; otherwise return as-is.
const inlineOrText = (s = "") => (hasDelims(s) ? s : `$${s}$`);
const blockOrText  = (s = "") => (hasDelims(s) ? s : `$$${s}$$`);

// KaTeX <BlockMath math="..."> expects NO delimiters → strip if present
const stripDelims = (s = "") =>
  s.replace(/^\s*(\$\$?|\\\[|\\\()/, "").replace(/(\$\$?|\\\]|\\\))\s*$/, "");


  const [gameOver, setGameOver] = useState({ reached: false, amount: "", emoji: "", message: "", bitmoji: "" });
  const [showTitleScreen, setShowTitleScreen] = useState(true);
  const { assignmentId } = useParams();
  const [questions, setQuestions] = useState([]);
  const [assignment, setAssignment] = useState(null);
  const [currentQIndex, setCurrentQIndex] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [showResult, setShowResult] = useState(false);
  const [isCorrect, setIsCorrect] = useState(false);
  const [visibleOptions, setVisibleOptions] = useState([]);
  const [phoneFriendTip, setPhoneFriendTip] = useState("");
  const [audienceVotes, setAudienceVotes] = useState([]);
  const [lifelinesUsed, setLifelinesUsed] = useState({ fiftyFifty: false, phoneFriend: false, askAudience: false });
  const [fullAudienceVotes, setFullAudienceVotes] = useState([]);
  const [animateBars, setAnimateBars] = useState(false);
  const [playerWorking, setPlayerWorking] = useState("");
  const welcomeAudioRef = useRef(null);
  const roundAudioRef = useRef(null);
  const correctSoundRef = useRef(null);
  const wrongSoundRef = useRef(null);
  const fiftyFiftySoundRef = useRef(null);
  const phoneSoundRef = useRef(null);
  const takeMoneySoundRef = useRef(null);
  const [musicEnabled, setMusicEnabled] = useState(true);
const [sfxEnabled, setSfxEnabled] = useState(true);
const winMusicRef = useRef(null);
const [questionStartTime, setQuestionStartTime] = useState(null);
const auth = getAuth();
const studentUID = auth.currentUser?.uid;
  const getRoundMusic = (index) => {
    if (index < 5) return "/Millionaire/Round1.mp3";
    if (index < 10) return "/Millionaire/Round2.mp3";
    return "/Millionaire/Round3.mp3";
  };
  useEffect(() => {
    if (roundAudioRef.current) roundAudioRef.current.volume = 0.1;
    if (welcomeAudioRef.current) welcomeAudioRef.current.volume = 0.1;
    if (winMusicRef.current) winMusicRef.current.volume = 0.1;
  }, []);
  useEffect(() => {
    if (!showTitleScreen && roundAudioRef.current) {
      roundAudioRef.current.pause();
      roundAudioRef.current.src = getRoundMusic(currentQIndex);
      roundAudioRef.current.load();
      roundAudioRef.current.volume = 0.1; // ✅ Reset volume right before playing
      if (musicEnabled) {
        roundAudioRef.current.play();
        
      }
      
    }
  }, [currentQIndex, showTitleScreen, musicEnabled]);
  useEffect(() => {
    if (correctSoundRef.current) correctSoundRef.current.volume = 0.1;
    if (wrongSoundRef.current) wrongSoundRef.current.volume = 0.2;
    if (fiftyFiftySoundRef.current) fiftyFiftySoundRef.current.volume = 0.2;
    if (phoneSoundRef.current) phoneSoundRef.current.volume = 0.1;
    if (takeMoneySoundRef.current) takeMoneySoundRef.current.volume = 0.2;
  }, []);

  const startGame = async () => {
    setShowTitleScreen(false);
  
    if (welcomeAudioRef.current) {
      welcomeAudioRef.current.pause();
      welcomeAudioRef.current.currentTime = 0;
    }
  
    if (assignmentId && studentUID) {
      const submissionId = `${studentUID}_${assignmentId}`;
      const submissionRef = doc(db, "studentAssignmentSubmissions", submissionId);
  
      try {
        await setDoc(submissionRef, {
          assignmentId,
          studentUID,
          type: "millionaire",
          timeStarted: serverTimestamp(),
          timeSubmitted: null,
          answers: [],
        });
        console.log("📝 Created Millionaire submission document");
      } catch (err) {
        console.error("❌ Failed to create submission doc:", err);
      }
    }
  };
 

  const moneyLadder = [
    "£100", "£200", "£300", "£500", "£1,000",
    "£2,000", "£4,000", "£8,000", "£16,000", "£32,000",
    "£64,000", "£125,000", "£250,000", "£500,000", "⭐£1 MILLION⭐"
  ];

  const CRYING_BITMOJI = "https://firebasestorage.googleapis.com/v0/b/ryan-tutors.firebasestorage.app/o/images%2Fbitmoji_cry.png?alt=media&token=247bf73a-1a2f-4f99-ad10-11da5a806ae8";
  const DISAPPOINTED_BITMOJI = "https://firebasestorage.googleapis.com/v0/b/ryan-tutors.firebasestorage.app/o/images%2Fbitmoji_ok.png?alt=media&token=dec93d22-c6da-41aa-8f93-6568265ab063";
  const THUMBSUP_BITMOJI = "https://firebasestorage.googleapis.com/v0/b/ryan-tutors.firebasestorage.app/o/images%2Fbitmoji_ok.png?alt=media&token=dec93d22-c6da-41aa-8f93-6568265ab063";
  const JACKPOT_BITMOJI = "https://firebasestorage.googleapis.com/v0/b/ryan-tutors.firebasestorage.app/o/images%2FBitmoji-jackpot.png?alt=media&token=a90935de-d124-4f80-a62c-b9c9174731e4";

  const getBitmojiForAmount = (amountStr) => {
    const amount = parseInt(amountStr.replace(/[^\d]/g, ""));
    if (amount <= 500) return CRYING_BITMOJI;
    if (amount <= 16000) return DISAPPOINTED_BITMOJI;
    return THUMBSUP_BITMOJI;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const assignmentRef = doc(db, "assignments", assignmentId);
                const assignmentSnap = await getDoc(assignmentRef);
        if (!assignmentSnap.exists()) return console.warn("Assignment not found.");

        const data = assignmentSnap.data();
        setAssignment(data);

        const questionDocs = await Promise.all(
          (data.questions || []).map((qid) => getDoc(doc(db, "questions", qid)))
        );

        const allQuestions = questionDocs.map((docSnap, i) => {
          const q = docSnap.data();
          if (!q) return null;
          const questionId = docSnap.id; // <-- ADD THIS
        
          const correct = q.answers?.[0] || q.answer || "";
          const options = Array.isArray(q.choices) && typeof q.choices[0] === "object"
            ? q.choices
            : (q.choices || []).map((text) => ({ text, isCorrect: text === correct }));
        
          return {
            questionId, // <-- ADD THIS TOO
            text: q.questionText || "",
            latex: q.questionLatex || "",
            optionalQuestionText: q.optionalQuestionText || "",
            answerPrefix: q.answerPrefix || "",
            answerSuffix: q.answerSuffix || "",
            paragraphs: q.questionParagraphs || [],
            correctAnswer: correct,
            options,
            difficulty: parseInt(q.difficulty || "1", 10)
          };
        });
        

        const sorted = allQuestions.sort((a, b) => a.difficulty - b.difficulty);
        const total = sorted.length;
        const selected = [];
        for (let i = 0; i < 15; i++) {
          const start = Math.floor((i / 15) * total);
          const end = Math.floor(((i + 1) / 15) * total);
          const bucket = sorted.slice(start, end);
          if (bucket.length > 0) {
            const randomQuestion = bucket[Math.floor(Math.random() * bucket.length)];
            selected.push(randomQuestion);
          }
        }

        setQuestions(selected);
      } catch (err) {
        console.error("Failed to load game data:", err);
      }
    };

    fetchData();
  }, [assignmentId]);

  useEffect(() => {
    if (questions.length > 0 && questions[currentQIndex]) {
      setVisibleOptions(questions[currentQIndex].options);
      setPhoneFriendTip("");
      setAudienceVotes([]);
      setFullAudienceVotes([]);
      setPlayerWorking(""); // ✅ This clears the text box
      setQuestionStartTime(new Date()); // ✅ Track when question is shown
    }
  }, [questions, currentQIndex]);

  const handleFiftyFifty = () => {
    if (lifelinesUsed.fiftyFifty || !questions[currentQIndex]) return;
    if (fiftyFiftySoundRef.current && sfxEnabled) {
      fiftyFiftySoundRef.current.currentTime = 0;
      fiftyFiftySoundRef.current.play();
    }
    
    const options = visibleOptions;
    const correctOption = options.find((opt) => opt.isCorrect);
    const incorrectOptions = options.filter((opt) => !opt.isCorrect);
    const randomIncorrect = incorrectOptions.sort(() => 0.5 - Math.random()).slice(0, 1);
    const newVisible = [correctOption, ...randomIncorrect].sort(() => 0.5 - Math.random());
    setVisibleOptions(newVisible);
    setLifelinesUsed({ ...lifelinesUsed, fiftyFifty: true });
  };
  const handlePhoneFriend = () => {
    if (lifelinesUsed.phoneFriend || !questions[currentQIndex]) return;
      // ✅ Play phone-a-friend sound
      if (phoneSoundRef.current && sfxEnabled) {
        phoneSoundRef.current.currentTime = 0;
        phoneSoundRef.current.play();
      }      
  const options = visibleOptions;
    const correctOption = options.find((opt) => opt.isCorrect);
    const incorrectOptions = options.filter((opt) => !opt.isCorrect);
    const accuracy = 0.9 - ((currentQIndex) * (0.6 / 14));
    const guessCorrect = Math.random() < accuracy;
    const friendGuess = guessCorrect
      ? correctOption
      : incorrectOptions[Math.floor(Math.random() * incorrectOptions.length)];
    setPhoneFriendTip(friendGuess.text);
    setLifelinesUsed({ ...lifelinesUsed, phoneFriend: true });
  };

  const handleAskAudience = () => {
    if (lifelinesUsed.askAudience || !questions[currentQIndex]) return;
    const options = questions[currentQIndex].options;
    const correctIndex = options.findIndex((opt) => opt.isCorrect);

    const baseAccuracy = 0.95 - ((currentQIndex) * (0.6 / 14));
    let votes = new Array(options.length).fill(0);
    let totalVotes = 100;

    votes[correctIndex] = Math.floor(baseAccuracy * totalVotes);
    let remaining = totalVotes - votes[correctIndex];

    const indices = options.map((_, idx) => idx).filter(i => i !== correctIndex);
    while (remaining > 0) {
      const idx = indices[Math.floor(Math.random() * indices.length)];
      votes[idx]++;
      remaining--;
    }

    setFullAudienceVotes(votes);
    setAnimateBars(false);
    setTimeout(() => setAnimateBars(true), 50);
    setAudienceVotes(votes);
    setLifelinesUsed({ ...lifelinesUsed, askAudience: true });
  };

  const handleTakeTheMoney = async () => {
    // ✅ Stop question music
  if (roundAudioRef.current) {
    roundAudioRef.current.pause();
  }

  // ✅ Play take money sound
  if (takeMoneySoundRef.current && sfxEnabled) {
    takeMoneySoundRef.current.currentTime = 0;
    takeMoneySoundRef.current.play();
  }
  
    const amount = moneyLadder[currentQIndex - 1] || "£0";
    const bitmoji = getBitmojiForAmount(amount);
    setGameOver({
      reached: true,
      amount,
      emoji: "💼",
      message: `You took the money and leave with ${amount}!`,
      bitmoji
    });
      // ✅ Save timeSubmitted to Firestore
  if (assignmentId && studentUID) {
    const submissionId = `${studentUID}_${assignmentId}`;
    const submissionRef = doc(db, "studentAssignmentSubmissions", submissionId);
    try {
      await updateDoc(submissionRef, {
        timeSubmitted: serverTimestamp(),
        finalAmount: amount,
      });
      console.log("📬 Submitted timestamp saved (took the money)");
    } catch (err) {
      console.error("❌ Failed to save timeSubmitted:", err);
    }
  }
  };

  const handleAnswer = (option) => {
    const isRight = option?.isCorrect;
  
    setSelectedOption(option);
    setIsCorrect(isRight);
    setShowResult(true);
  
    if (isRight && correctSoundRef.current && sfxEnabled) {
      correctSoundRef.current.currentTime = 0;
      correctSoundRef.current.play();
    } else if (!isRight && wrongSoundRef.current && sfxEnabled) {
      wrongSoundRef.current.currentTime = 0;
      wrongSoundRef.current.play();
    }
  
    setTimeout(async () => {
      if (assignmentId && studentUID) {
        const submissionId = `${studentUID}_${assignmentId}`;
        const submissionRef = doc(db, "studentAssignmentSubmissions", submissionId);
        const answerObject = {
          correct: isRight,
          playerAnswer: option.text,
          working: playerWorking || "",
          questionId: questions[currentQIndex]?.questionId || "",
          timeStarted: questionStartTime || new Date(),
          timeSubmitted: new Date(),
              };
  
        try {
          const submissionSnap = await getDoc(submissionRef);
          const existingAnswers = submissionSnap.exists() ? submissionSnap.data().answers || [] : [];
          console.log("✅ Existing answers:", existingAnswers); // add this
          await updateDoc(submissionRef, {
            answers: [...existingAnswers, answerObject]
          });
  
          console.log("📥 New answer appended:", answerObject); // add this
        } catch (err) {
          console.error("❌ Failed to save answer:", err);
        }
      }
  
      if (!isRight) {
        if (roundAudioRef.current) {
          roundAudioRef.current.pause();
        }
  
        const result = currentQIndex <= 4
          ? { amount: "£0", emoji: "💥", message: "You got a question wrong and go home with £0.", bitmoji: CRYING_BITMOJI }
          : currentQIndex <= 9
          ? { amount: "£1,000", emoji: "😢", message: "You leave with £1,000!", bitmoji: DISAPPOINTED_BITMOJI }
          : { amount: "£32,000", emoji: "😢", message: "You leave with £32,000!", bitmoji: THUMBSUP_BITMOJI };
  
        setGameOver({ reached: true, ...result });
  
        // ✅ Save timeSubmitted to Firestore on wrong answer
        if (assignmentId && studentUID) {
          const submissionId = `${studentUID}_${assignmentId}`;
          const submissionRef = doc(db, "studentAssignmentSubmissions", submissionId);
          try {
            await updateDoc(submissionRef, {
              timeSubmitted: serverTimestamp(),
              finalAmount: result.amount,
            });
            console.log("📬 Submitted timestamp saved (wrong answer)");
          } catch (err) {
            console.error("❌ Failed to save timeSubmitted (wrong answer):", err);
          }
        }
      } else if (currentQIndex === 14) {
        if (roundAudioRef.current) {
          roundAudioRef.current.pause();
        }
  
        if (musicEnabled && winMusicRef.current) {
          winMusicRef.current.currentTime = 0;
          winMusicRef.current.play();
        }
  
        setGameOver({ reached: true, amount: "£1,000,000", emoji: "🎉", message: "You leave with £1,000,000!", bitmoji: JACKPOT_BITMOJI });
      } else {
        setShowResult(false);
        setSelectedOption(null);
        setCurrentQIndex(prev => prev + 1);
      }
    }, 1500);
  };
  

  const renderQuestionContent = (question) => {
   const { paragraphs = [], text = "", latex = "", optionalQuestionText = "" } = question;

   // helper: image url?
   const isImg = (s) => /^https?:\/\/.+\.(png|jpe?g|webp|gif|svg)$/i.test(s || "");

   if (paragraphs.length > 0) {
     return paragraphs.map((raw, i) => {
       let p = raw;
       // if Firestore sometimes gives JSON strings, try parse
       if (typeof p === "string") {
         try {
           const maybe = JSON.parse(p);
           if (maybe && (maybe.text || maybe.image)) p = maybe;
         } catch {/* leave as string */}
       }

       return (
  <div key={i} style={{ marginBottom: "1rem", lineHeight: 1.6, textAlign: "center" }}>
   {typeof p === "string" ? (
  isImg(p)
    ? <img src={p} alt={`Q${i + 1}`} style={{ maxWidth: "100%", maxHeight: 250, display: "block", margin: "0 auto" }} />
    : looksLikeLatex(p)
      ? <BlockMath math={stripDelims(p)} />   // ✅ Use block math for standalone
      : <div>{p}</div>

    ) : (
      <>
        {p.text && (
          <div>
            {looksLikeLatex(p.text)
 ? <div style={{ textAlign: "center" }}>
    <BlockMath math={stripDelims(p.text)} />
  </div>

  : <p style={{ margin: 0 }}>{p.text}</p>}

          </div>
        )}
        {p.image && (
          <img
            src={p.image}
            alt={`Q${i + 1}`}
            style={{ maxWidth: "100%", maxHeight: 250, display: "block", margin: "0.5rem auto 0" }}
          />
        )}
      </>
    )}
  </div>
);

     });
   }

   // Fallback when no paragraphs array
   return (
     <div style={{ textAlign: "center", lineHeight: 1.6 }}>
      {text && text.split("\n").map((line, i) => (
  <div key={i} style={{ marginBottom: "0.5rem", textAlign: "center" }}>
    {looksLikeLatex(line)
      ? <Latex>{inlineOrText(line)}</Latex>
      : <span>{line}</span>}
  </div>
))}


       {latex && (
  <div style={{ display: "flex", justifyContent: "center", margin: "0.5rem 0" }}>
    <BlockMath math={stripDelims(latex)} />
  </div>
)}



       {optionalQuestionText && (
  <div style={{ marginTop: "0.5rem", fontWeight: "bold" }}>
    {looksLikeLatex(optionalQuestionText)
      ? <Latex>{inlineOrText(optionalQuestionText)}</Latex>
      : <span>{optionalQuestionText}</span>}
  </div>
)}

     </div>
   );
 };

  const currentQuestion = questions[currentQIndex];

  return (
    <StudentLayout>
      {showTitleScreen ? (
        <div className="welcome-screen">
        {musicEnabled && (
  <audio ref={welcomeAudioRef} src="/Millionaire/Who_Wants_To_Be_A_Millionaire_Theme.mp3" autoPlay loop />
)}
          <img src="https://firebasestorage.googleapis.com/v0/b/ryan-tutors.firebasestorage.app/o/images%2FBitmoji_wave.png?alt=media&token=68db9705-382e-4ae2-b718-f5808de26268" alt="Bitmoji" className="bitmoji" />
          <div className="logo-wrapper">
            <img src="https://firebasestorage.googleapis.com/v0/b/ryan-tutors.firebasestorage.app/o/images%2FMillionaire%20Logo.png?alt=media&token=64690774-c189-4a45-8b88-4eabf0ed0a55" alt="Millionaire Logo" className="millionaire-logo" />
          </div>
          <button className="start-btn" onClick={startGame}>Start Game</button>
        </div>
      ) : (
        <>
          <audio ref={roundAudioRef} />
          <div className="millionaire-wrapper">
            {!gameOver.reached && (
              <>
               <div className="audio-toggles" style={{ textAlign: "center", marginBottom: "1rem" }}>
  <button onClick={() => setMusicEnabled(prev => !prev)}>
    🎵 Music: {musicEnabled ? "ON" : "OFF"}
  </button>
  <button onClick={() => setSfxEnabled(prev => !prev)} style={{ marginLeft: "1rem" }}>
    🔊 Sound FX: {sfxEnabled ? "ON" : "OFF"}
  </button>
</div>

                <div style={{ textAlign: "center", marginBottom: "1rem" }}>
                  <button className="take-money-btn" onClick={handleTakeTheMoney}>💼 Take the Money</button>
                </div>

                <div className="lifelines">
                  <img
                    src="https://firebasestorage.googleapis.com/v0/b/ryan-tutors.firebasestorage.app/o/images%2F50-50.gif?alt=media&token=4453e297-63ec-4e3d-9be2-9716a38f580f"
                    alt="50:50"
                    className={`lifeline-icon ${lifelinesUsed.fiftyFifty ? "used" : ""}`}
                    onClick={handleFiftyFifty}
                  />
                  <img
                    src="https://firebasestorage.googleapis.com/v0/b/ryan-tutors.firebasestorage.app/o/images%2FPhone%20a%20Friend.gif?alt=media&token=b2a4f76a-5b0b-4cfb-91fd-0292d4d24ca9"
                    alt="Phone a Friend"
                    className={`lifeline-icon ${lifelinesUsed.phoneFriend ? "used" : ""}`}
                    onClick={handlePhoneFriend}
                  />
                  <img
                    src="https://firebasestorage.googleapis.com/v0/b/ryan-tutors.firebasestorage.app/o/images%2FAsk%20The%20Audience.gif?alt=media&token=45572f27-6256-47b0-ad60-883b9486542b"
                    alt="Ask the Audience"
                    className={`lifeline-icon ${lifelinesUsed.askAudience ? "used" : ""}`}
                    onClick={handleAskAudience}
                  />
                </div>
              </>
            )}

            {phoneFriendTip && (
              <div className="lifeline-tip">
                <p>📞 Your friend thinks the answer is:</p>
                <BlockMath math={phoneFriendTip} />
              </div>
            )}

            {gameOver.reached ? (
              <div className="game-over-screen fade-in">
                <h2>{gameOver.emoji} Game Over!</h2>
                <p>{gameOver.message}</p>
                <img src={gameOver.bitmoji} alt="Bitmoji" className="bitmoji-sad" />
                <button className="try-again-btn" onClick={() => window.location.reload()}>🔁 Try Again</button>
              </div>
            ) : currentQIndex >= questions.length ? (
              <h2>🏆 You've finished the game!</h2>
            ) : currentQuestion ? (
              <div className="game-layout">
                <div className="working-box" style={{ flex: "0 0 250px",
    background: "#0d1b2a",
    padding: "1rem",
    borderRadius: "12px",
    color: "white",
    minHeight: "250px",
    transform: "translateX(-230px)" }}>
    <h3 style={{ fontSize: "1.1rem", marginBottom: "0.5rem" }}>📝 Show Your Working</h3>
    <textarea
      placeholder="Write your working here..."
      value={playerWorking}
  onChange={(e) => setPlayerWorking(e.target.value)}
      style={{
        width: "100%",
        height: "200px",
        borderRadius: "8px",
        padding: "0.5rem",
        resize: "vertical",
        fontFamily: "inherit",
        backgroundColor: "#1c3a6b",
        color: "white"
      }}
    />
  </div>
                
                <div key={currentQIndex} className={`question-block animated ${showResult && !isCorrect && currentQIndex <= 4 ? "fade-out" : ""}`}
                style={{ marginLeft: "-225px" }}>
                  <h2>Question {currentQIndex + 1}</h2>
                  <div className="question-content">{renderQuestionContent(currentQuestion)}</div>
                  <div className="options-grid">
                    {visibleOptions.map((opt, idx) => (
                      <button
                        key={idx}
                        className={`option-btn ${selectedOption === opt ? (isCorrect ? "correct" : "wrong") : ""}`}
                        onClick={() => handleAnswer(opt)}
                        disabled={showResult}
                      >
                        <BlockMath math={opt.text} />
                      </button>
                    ))}
                  </div>
                  {fullAudienceVotes.length > 0 && visibleOptions.length > 0 && (
                    <div style={{ marginTop: "1rem", display: "flex", justifyContent: "center" }}>
                      <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <p style={{ fontWeight: "bold", textAlign: "center", marginBottom: "0.75rem", fontSize: "1.1rem" }}>
                          📊 Ask the Audience
                        </p>
                        <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "center", gap: "2rem" }}>
                          {visibleOptions.map((opt, i) => {
                            const indexInFull = questions[currentQIndex].options.findIndex(o => o.text === opt.text);
                            const percent = fullAudienceVotes[indexInFull] || 0;
                            const height = percent * 2;
                            return (
                              <div key={i} style={{ textAlign: "center" }}>
                                <div style={{ marginBottom: "0.25rem", fontWeight: "bold" }}>{percent}%</div>
                                <div
                                  className={`audience-bar-fill ${animateBars ? 'filled' : ''}`}
                                  style={{ height: `${animateBars ? height : 0}px` }}
                                ></div>
                                <div style={{ marginTop: "0.5rem" }}>
                                  <BlockMath math={opt.text} />
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  )}
                  {showResult && <p className="result-text">{isCorrect ? "✅ Correct!" : "❌ Wrong!"}</p>}
                </div>
                <div className="money-ladder">
                  {[...moneyLadder].reverse().map((amount, i) => {
                    const level = moneyLadder.length - 1 - i;
                    return (
                      <div key={amount} className={`ladder-step ${level === currentQIndex - 1 ? "active-step" : ""}`}>
                        {amount}
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : <p>Loading game...</p>}
          </div>
        </>
      )}
      <audio ref={correctSoundRef} src="/Millionaire/correct2.mp3" preload="auto" />
      <audio ref={wrongSoundRef} src="/Millionaire/wrong.mp3" preload="auto" />
      <audio ref={fiftyFiftySoundRef} src="/Millionaire/fiftyfifty.mp3" preload="auto" />
      <audio ref={phoneSoundRef} src="/Millionaire/phoneafriend3.mp3" preload="auto" />
      <audio ref={takeMoneySoundRef} src="/Millionaire/wrong.mp3" preload="auto" />
      <audio ref={winMusicRef} src="/Millionaire/win.mp3" preload="auto" />
    </StudentLayout>
  );
};

export default MillionaireGame;
